import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { SessaoProvider } from "./features/auth/SessaoProvider";
import { LimiteDeErro } from "./shared/ui/LimiteDeErro";
import "./styles/global.css";

const raiz = document.getElementById("raiz");
if (raiz === null) throw new Error("Elemento #raiz nao encontrado no index.html.");

/** Sem repetição automática: o `ClienteHttp` já repete o que é seguro repetir,
 * e uma segunda camada de tentativas dobraria o tempo até a pessoa ver o erro.
 */
const cliente = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: true } },
});

/** O limite da raiz é a rede de baixo, e é o único que precisa existir para
 * que a tela **nunca** fique em branco: falha em provedor, na composição ou
 * numa região que esqueceu o próprio limite para aqui.
 *
 * Fica dentro do `StrictMode` e por fora dos provedores de propósito: um erro
 * ao montar o `QueryClientProvider` ou o `SessaoProvider` também precisa de
 * alguém para capturá-lo. Recarregar é a saída certa neste nível — o estado da
 * aplicação inteira é o que está em dúvida. */
createRoot(raiz).render(
  <StrictMode>
    <LimiteDeErro
      area="O Tanzuh"
      acaoSecundaria={{
        rotulo: "Recarregar a página",
        aoAcionar: () => {
          window.location.reload();
        },
      }}
    >
      <QueryClientProvider client={cliente}>
        <SessaoProvider>
          <App />
        </SessaoProvider>
      </QueryClientProvider>
    </LimiteDeErro>
  </StrictMode>,
);
